// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_lu-0";